import { __extends } from "tslib";
import React from 'react';
import { Wrapper } from './styled';
var Frame = /** @class */ (function (_super) {
    __extends(Frame, _super);
    function Frame() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            var onClick = _this.props.onClick;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
        _this.handleKeyPress = function (event) {
            if (event.key !== ' ' && event.key !== 'Enter') {
                return;
            }
            var onClick = _this.props.onClick;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
        // prevent default on mousedown to avoid inline card losing focus
        _this.handleMouseDown = function (e) {
            e.preventDefault();
        };
        return _this;
    }
    Frame.prototype.render = function () {
        var _a = this.props, isSelected = _a.isSelected, children = _a.children, onClick = _a.onClick, link = _a.link, withoutBackground = _a.withoutBackground, testId = _a.testId;
        var isInteractive = Boolean(onClick);
        return (React.createElement(Wrapper, { href: link, withoutBackground: withoutBackground, isSelected: isSelected, isInteractive: isInteractive, tabIndex: isInteractive ? 0 : undefined, role: isInteractive ? 'button' : undefined, onClick: this.handleClick, onMouseDown: this.handleMouseDown, onKeyPress: this.handleKeyPress, "data-testid": testId }, children));
    };
    return Frame;
}(React.Component));
export { Frame };
//# sourceMappingURL=index.js.map